import { useState, useEffect } from "react";
import api from "../api";

export default function MessageSendForm({ recipientId, recipientName, onSent }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [users, setUsers] = useState([]);
  const [recipient, setRecipient] = useState(recipientId || "");
  const [search, setSearch] = useState("");

  // Lade Nutzerliste für Dropdown
  useEffect(() => {
    // If recipient is pre-defined, skip loading users (works for non-admins too)
    if (recipientId) return;
    api.get("/admin/users", { params: { status: "active", limit: 100 } })
      .then(res => setUsers(res.data.items || []))
      .catch(e => {
        setError(e?.response?.data?.error || "Fehler beim Laden der Nutzerliste");
        console.error("User fetch error:", e);
      });
  }, [recipientId]);

  // Autocomplete-Filter
  const filteredUsers = users.filter(u => {
    const q = search.toLowerCase();
    return u.displayName?.toLowerCase().includes(q) || u.username?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q);
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const { data } = await api.post("/messages/send", {
        recipientId: recipient,
        subject,
        body
      });
      setSuccess("Nachricht erfolgreich gesendet.");
      setError("");
      setLoading(false);
      if (onSent) onSent({ success: true, data });
      // Reset fields after success
      setTimeout(() => {
        setSubject("");
        setBody("");
        setRecipient("");
        setSearch("");
        setSuccess("");
      }, 1200);
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler beim Senden der Nachricht");
      setSuccess("");
      setLoading(false);
      if (onSent) onSent({ success: false, error: e });
    }
  };

  const lockRecipient = !!recipientId;

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: "32px auto", padding: 24, background: "#222", borderRadius: 12, color: "#fff" }}>
      <h3 style={{ textAlign: "center", marginBottom: 18 }}>Neue Nachricht senden</h3>
      {error && !lockRecipient && <div style={{ color: "#c00", marginBottom: 12 }}>{error}</div>}
      {success && <div style={{ color: "#32CD89", marginBottom: 12 }}>{success}</div>}
      <div style={{ marginBottom: 12 }}>
        <label style={{ fontWeight: 500, marginBottom: 6, display: 'block' }}>Empfänger</label>
        {lockRecipient ? (
          <div style={{ padding: '10px 14px', background: '#111', borderRadius: 8 }}>
            {recipientName || `User #${recipientId}`}
          </div>
        ) : (
          <>
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Mitglied suchen..."
              style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "none", fontSize: "1em", marginBottom: 6 }}
            />
            <select
              value={recipient}
              onChange={e => setRecipient(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "none", fontSize: "1em" }}
              required
            >
              <option value="">Empfänger auswählen...</option>
              {filteredUsers.map(u => (
                <option key={u.id} value={u.id}>
                  {u.displayName ? `${u.displayName} (${u.username})` : u.username} - {u.email}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      <div style={{ marginBottom: 12 }}>
        <input
          type="text"
          value={subject}
          onChange={e => setSubject(e.target.value)}
          placeholder="Betreff (optional)"
          style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "none", fontSize: "1em" }}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <textarea
          value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Nachricht..."
          required
          rows={5}
          style={{ width: "100%", padding: "10px 14px", borderRadius: 8, border: "none", fontSize: "1em" }}
        />
      </div>
      <button type="submit" disabled={loading || !body || !recipient} style={{ background: "#32CD89", color: "#fff", padding: "10px 22px", borderRadius: 8, fontWeight: 600, border: "none", boxShadow: "0 2px 8px #32CD8940", cursor: "pointer" }}>
        {loading ? "Senden..." : "Nachricht senden"}
      </button>
    </form>
  );
}
